import {NgModule} from '@angular/core';
import {LinkModule} from './link';
import {LoaderModule} from './loader';
import {NotificationModule} from './notification';
import {PipesModule} from './pipes';
import {StickyModule} from './sticky';
import {TaggingModule} from './tagging';
import {CustomErrorModule} from './errors/custom-error.module';
import {SimSelectorModule} from './sim-selector';
import {InputAdderModule} from './input-adder';
import { BottomCardModule } from './bottom-card/bottom-card.module';
import { MessageCardModule } from './message-card/message-card.module';
import { FormOptionButtonModule } from './form-option-button/form-option-button.module';
import { CustomInputsModule } from './custom-inputs/custom-inputs-module';
import { FormOptionListModule } from './form-option-list/form-option-list.module';

@NgModule({
  imports: [
    LinkModule,
    LoaderModule,
    NotificationModule,
    PipesModule,
    StickyModule,
    TaggingModule,
    CustomErrorModule,
    SimSelectorModule,
    InputAdderModule,
    BottomCardModule,
    MessageCardModule,
    CustomInputsModule,
    FormOptionListModule
  ],
  exports: [
    LinkModule,
    LoaderModule,
    NotificationModule,
    PipesModule,
    StickyModule,
    TaggingModule,
    CustomErrorModule,
    SimSelectorModule,
    InputAdderModule,
    BottomCardModule,
    MessageCardModule,
    FormOptionButtonModule,
    CustomInputsModule,
    FormOptionListModule
  ],
  declarations: [

  ]
})
export class MyvfSharedModule {
}
